import React from "react";
import { ArrowForward } from "@mui/icons-material";
import { Button, FormControl, IconButton, Tooltip } from "@mui/material";
import { Input, Label } from "@100mslive/roomkit-react";
import { InfoIcon } from "../../../../icons";

const SendgrindDomain = props => {
  const { onNext, email, setEmail } = props;

  return (
    <React.Fragment>
      <div className="events-page-setup-steps-body">
        <div className="events-page-setup-steps-body-label">
          CONFIGURE EMAIL DOMAIN
        </div>
        <div className="events-page-setup-steps-body-title mb-10">
          Email Domain
        </div>

        <div className="events-page-setup-steps-body-text">
          If you are migrating to 6ix and have been sending emails from a custom
          domain on your previous platform, we strongly recommend that you use
          that domain or subdomain. This ensures you will maintain domain
          reputation that you have built and minimize chance of deliverability
          issues.
        </div>

        <FormControl className="custom-form-group">
          <div className="events-sendgrid-box">
            <Label
              className="events-sendgrid-box-title"
              htmlFor="onboard-org-name"
            >
              Enable a new domain or subdomain{" "}
              <Tooltip
                placement="top"
                arrow
                title="Enter your custom email address that you want to use for sending events promotional emails."
              >
                <IconButton>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </Label>
            <Input
              type="email"
              placeholder="hi@yourdomain.com"
              id="onboard-org-name"
              className="custom-form-input"
              onChange={e => setEmail(e.target.value)}
              value={email}
              name="email"
            />
          </div>
        </FormControl>

        <div className="text-center">
          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="events6ix-btn  events6ix-btn-primary mt-20"
            type="button"
            onClick={onNext}
            endIcon={<ArrowForward />}
          >
            continue
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SendgrindDomain;
